export { default } from "./ChallengeDetailCard";
